import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "padding": "0"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    title: "治丧流程",
    style: {
      "background-color": "lightblue"
    }
  }), _createElementVNode("div", {
    style: _normalizeStyle([{
      "padding": "0rem",
      "text-align": "center",
      "background-color": "#D8E3E7"
    }, {
      'minHeight': $data.viewhight + 'px'
    }])
  }, [_cache[1] || (_cache[1] = _createElementVNode("div", null, [_createElementVNode("img", {
    src: "/img/t6.jpg",
    width: "100%",
    height: "120",
    alt: ""
  })], -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: "/img/process.jpg",
    width: "100%",
    height: "500",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.preview && $options.preview(...args))
  })])], 4)]);
}